// extracted by mini-css-extract-plugin
export default {"container":"PlanTypeSegmentedControl-module__container--xed_H","segment":"PlanTypeSegmentedControl-module__segment--ybidF"};